
import React, { useState } from "react";
import styles from "./Graduation.module.css";

import GraduationDistribution from "./components/DistributionTable";
import GraduationOverview from "./components/Overview";

import { CPSC } from "./../../commons/mock/MockProgram"

import nav_styles from "./../../commons/components/navbar/NavBar.module.css";
import img_logo from "./../../commons/images/ma_logo.png";
import { NavLink } from "react-router-dom";

function NavBar() {
  return (
    <div className={nav_styles.NavBar}>
      
      <div style={{ marginLeft: "20px" }}>
        <img src={img_logo} alt="" style={{ width: "150px", height: "auto", marginRight: "10px" }}/>
      </div>

      <div className={nav_styles.row} style={{ marginRight: "20px" }}>
        <NavLink to="/" className={({ isActive }) => isActive ? nav_styles.activeLink : nav_styles.dormantLink }>
          Graduation
        </NavLink>
        <NavLink to="/courses" className={({ isActive }) => isActive ? nav_styles.activeLink : nav_styles.dormantLink }>
          Courses
        </NavLink>
        <NavLink to="/majors" className={({ isActive }) => isActive ? nav_styles.activeLink : nav_styles.dormantLink }>
          Majors
        </NavLink>
        {/* <MeDropdown /> */}
      </div>
    </div>
  );
}

function Recommendations(){
  return(
    <div>
      <div style={{ fontSize: "30px", fontWeight: "500" }}>
        Hello, Ryan!
      </div>
    </div>
  );
}

function Graduation() {

const UserYear = () => { return 2; }
const [currYear, setCurrYear] = useState(UserYear());
const alterCurrYear = (num: number) => { 
  setCurrYear(num); 
};

return (
  <div>
    
    <NavBar/>
    
    <div className={styles.GraduationPage}>
      <div className={styles.row}>
        <div className={styles.column} style={{ marginRight: "60px" }}>
          <Recommendations/>
          <GraduationDistribution currYear={currYear} alterCurrYear={alterCurrYear}/>
        </div>
        <GraduationOverview degree={CPSC.degrees[0]}/>
      </div>
    </div>
  </div>
);
}

export default Graduation;

